export default __webpack_public_path__ + "static/media/portrait5.4963112d.JPG";